import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: { [key: string]: string } = {};

export const storageSlice = createSlice({
  name: "storage",
  initialState: initialState,
  reducers: {
    setUrl: (state, action: PayloadAction<{ path: string; url: string }>) => {
      state[action.payload.path] = action.payload.url;
    },
    resetStorage: () => {
      return initialState;
    },
  },
});

export const { setUrl, resetStorage } = storageSlice.actions;

export default storageSlice.reducer;
